import {GET_RESCHEDULE_SHIFT_DAYS} from "../../../enums/Request/request.types";

export const getRescheduleDaysAction = (arrayOfAvailableDays) => {
    return {
        type: GET_RESCHEDULE_SHIFT_DAYS,
        payload: arrayOfAvailableDays,
    };
};
